import type { PathElement } from "@cva/shared";
import { type BrandLink, ColorButton } from "./ColorPicker";
import { useEditorApi } from "./store";
import { NumberField, Row, Section } from "./ui";

/** Scale of the stroke: the viewBox is stretched onto the box. */
function strokeScale(element: PathElement): number {
  return Math.min(element.width / element.viewBox[0], element.height / element.viewBox[1]);
}

/** Properties of drawn strokes: colour and visible stroke width. */
export function PathProperties({
  elements,
  colorLink,
}: {
  elements: PathElement[];
  colorLink?: BrandLink | undefined;
}) {
  const store = useEditorApi();
  const first = elements[0]!;
  const ids = elements.map((element) => element.id);
  const update = (recipe: (target: PathElement) => void, merge?: string) =>
    store.getState().update(
      (draft) => {
        for (const id of ids) {
          const target = draft.elements[id];
          if (target?.type === "path") recipe(target);
        }
      },
      merge ? { merge } : undefined,
    );
  const visibleWidth = first.strokeWidth * strokeScale(first);
  return (
    <Section title="Zeichnung">
      <Row>
        <span className="w-20 shrink-0 text-xs text-zinc-500">Farbe</span>
        <ColorButton
          value={first.color}
          onChange={(color) => update((target) => (target.color = color))}
          brandLink={colorLink}
        />
      </Row>
      <NumberField
        label="Stärke"
        value={Math.round(visibleWidth * 10) / 10}
        unit="px"
        min={0.5}
        step={1}
        onChange={(v) =>
          update((target) => {
            const scale = strokeScale(target) || 1;
            target.strokeWidth = Math.max(0.1, Math.min(500, v / scale));
          }, "pathStroke")
        }
      />
    </Section>
  );
}
